import {useMsal} from "@azure/msal-react";

export default function LogoutPage() {
  const {instance} = useMsal();
  instance.logoutRedirect().then(t => console.log(t)).catch(e => console.error(e))
  return <></>
}
